import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { NotificationsService } from 'angular2-notifications';
import { NWCMPointDef, NWCMStatusMonthData, NWCMPointData, GenResponse } from 'app/shared/misc-classes';
import { GenService } from 'app/shared/gen-ser.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ErrorPopupComponent } from 'app/common/error-popup/error-popup.component';

@Component({
  selector: 'nwcm-tree',
  templateUrl: './nwcm-tree.component.html',
  styleUrls: ['./nwcm-tree.component.css']
})
export class NwcmTreeComponent implements OnInit {

  mId:string = "a81354b1-5310-4597-438a-27e6cb819cef";
  hasmodaccess:boolean = false;
  imgWidth:number = 20;
  widthFactor:number = 1.0;
  heightFactor:number = 1.0;
  refDevWidth:number = 1207;
  refDevHeight:number = 653;
  editHeader:string = '';
  editNwcTreeDocTs :number = null;

  isLoading:boolean = false;
  isLoaded:boolean = false;
  isFailed:boolean = false;
  isImgLoading:boolean = false;
  kpiImageFlag :boolean = false;
  failMessage:string = '';
  areChangesMade: boolean = false;

  currMonthDtObj: Date = new Date();
  editStatusValue:string = "0";
  editPointRef:NWCMPointDef;

  editDocId:string = "";
  editMonthStr:string = "";
  image = '//placehold.it/100';

  @ViewChild('nwcmimg') imgElt:ElementRef;
  @ViewChild('dummyScrlElement') scrlDiv:ElementRef;

  @ViewChild('childModal') public childModal:ModalDirective;  
  @ViewChild('enlargeImageModal') public enlargeImageModal: ModalDirective;
  @ViewChild(ErrorPopupComponent) errorPopup:ErrorPopupComponent;
  
  _pointArray:NWCMPointDef[] = [
    new NWCMPointDef("1", 203, 59, 17, "0", "Final FPY", ""),
    new NWCMPointDef("2", 173, 89, 17, "0", "Stagewise FPY", ""),
    new NWCMPointDef("3", 144, 114, 17, "0", "Incoming FPY", ""),
    new NWCMPointDef("4", 405, 135, 17, "0", "Review Mfg Variance", ""),
    new NWCMPointDef("5", 346, 189, 17, "0", "FPY Improvement", ""),
    new NWCMPointDef("6", 167, 230, 17, "0", "Safety stock reduction", ""),
    new NWCMPointDef("7", 142, 256, 17, "0", "Export Inventory", ""),
    new NWCMPointDef("8", 133, 293, 17, "0", "Development specific inventory", ""),
    new NWCMPointDef("9", 243, 274, 17, "0", "MRP Exceptions", ""),
    new NWCMPointDef("10", 332, 294, 17, "0", "Inventory Obsolecence", ""),
    new NWCMPointDef("11", 279, 350, 17, "0", "PO Creation to GRN cycle", ""),
    new NWCMPointDef("12", 219, 358, 17, "0", "Inventory against Forecast", ""),
    new NWCMPointDef("13", 202, 397, 17, "0", "MM Updation / Review", ""),
    new NWCMPointDef("14", 185, 431, 17, "0", "BOM Correctness", ""),
    new NWCMPointDef("15", 253, 518, 17, "0", "Supplier InCo terms", ""),
    new NWCMPointDef("16", 253, 560, 17, "0", "Supplier OTD", ""),
    new NWCMPointDef("17", 253, 599, 17, "0", "LCC Sourcing", ""),
    new NWCMPointDef("18", 627, 144, 17, "0", "Reduction in Conversion and diversion", ""),
    new NWCMPointDef("19", 662, 107, 17, "0", "FG pick up ratio", ""),
    new NWCMPointDef("20", 718, 102, 17, "0", "SO Scheduling Accuracy", ""),
    new NWCMPointDef("21", 787, 142, 17, "0", "Reduce TTPT", ""),
    new NWCMPointDef("22", 785, 239, 17, "0", "FG Waiting time Reduction", ""),
    new NWCMPointDef("23", 582, 533, 17, "0", "Trade Payable %", ""),
    new NWCMPointDef("24", 589, 448, 17, "0", "Inventory %", ""),
    new NWCMPointDef("25", 707, 383, 17, "0", "Trade Receivables %", ""),
    new NWCMPointDef("26", 768, 271, 17, "0", "Inv TurnsSpot", ""),
    new NWCMPointDef("27", 768, 293, 17, "0", "Inv Turns Avg", ""),
    new NWCMPointDef("28", 860, 282, 17, "0", "ZFOC Cost reduction", ""),
    new NWCMPointDef("29", 860, 314, 17, "0", "AOT", ""),
    new NWCMPointDef("30", 860, 349, 17, "0", "ROT", ""),
    new NWCMPointDef("31", 1020, 255, 17, "0", "PO to SO creation time", ""),
    new NWCMPointDef("32", 1020, 275, 17, "0", "SO creation to release time", ""),
    new NWCMPointDef("33", 1025, 347, 17, "0", "Customer PO C40 Cycle", ""),
    new NWCMPointDef("34", 1030, 382, 17, "0", "Unclear SO(planning)", ""),
    new NWCMPointDef("35", 1026, 418, 17, "0", "Forecast Accuracy", ""),
    new NWCMPointDef("36", 953, 457, 17, "0", "Plan V/s Actual Deviation", ""),
    new NWCMPointDef("37", 1013, 541, 17, "0", "Non Trade Receivables", ""),
    new NWCMPointDef("38", 510, 600, 17, "0", "DPO - Spot", ""),
    new NWCMPointDef("39", 780, 541, 17, "0", "DSO - Spot", ""),
    new NWCMPointDef("40", 887, 493, 17, "0", "Overdue receivables & Legal Action", "")
  ];
  //_samplePoint:NWCMPointDef = new NWCMPointDef("1",203,59,17,"1");
  

  constructor(public _dataService: DataService,private _notify: NotificationsService) { }

  ngOnInit() {
    this._dataService.currPageName = "Net Working Capital Tree";

    this.loadMonthData();
   // this.goToBottom('srl');
  }

  checkModAccess():boolean{
    if(this._dataService.mAccess(this.mId) == true){
      this.hasmodaccess = true; 
    }
    else{
      this.hasmodaccess = false; 
    }
    return this.hasmodaccess;
  }
  hasEditAccess(_pid:string){
    return this._dataService.hasEditAccess(this.mId,_pid);
  }
  hasReadAccess(_pid:string){
    return this._dataService.hasReadAccess(this.mId,_pid);
  }

  imageLoaded(evnt){
    this.redrawPoints();
    this.scrlDiv.nativeElement.scrollIntoView(false);
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }
  imageResized(evnt){
    this.redrawPoints();
    //console.log(this.imgElt.nativeElement.offsetWidth);
  }

  private redrawPoints():void{
    var _tmpImgWidth:number = this.imgElt.nativeElement.offsetWidth;
    var _tmpImgHeight:number = this.imgElt.nativeElement.offsetHeight;
    this.widthFactor =  _tmpImgWidth / this.refDevWidth;
    this.heightFactor =  _tmpImgHeight / this.refDevHeight;
  }

  getNWCMPointLeft(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getLeft(this.widthFactor);
  }

  getNWCMPointWidth(_tmpPoint:NWCMPointDef):number{
    return _tmpPoint.getWidth(this.widthFactor);
  }

  getNWCMPointTop(_tmpPoint:NWCMPointDef):string{
    return _tmpPoint.getTop(this.heightFactor);
  }

  public formatMonth(_dateObj: Date): string {
    if (_dateObj) {
      return GenService.getDateFormatStr(_dateObj, "MMM-YYYY");
    }
    return '-';
  }

  PointClicked(_tmpPoint:NWCMPointDef){
    if(_tmpPoint!=null){
      this.editPointRef = _tmpPoint;
      this.editStatusValue = this.editPointRef.Status;
      this.editHeader = this.editPointRef.Title;
      if (this.editPointRef.ImageRef) {
        this.kpiImageFlag = true
        this.isImgLoading = true;
        this._dataService.getKpiImage(this.editPointRef.ImageRef).subscribe((_retVal: boolean) => {
          this.image = this._dataService.KpiImage.Base64Data;
          this.isImgLoading = false;
        });
      } else {
        this.kpiImageFlag = false;
        this.image = '//placehold.it/100';
      }
      this.childModal.show();
    }
    
  }

  editStatusChanged(_newStatus:string){
    this.editStatusValue = _newStatus;
  }

  public discardChanges():void {
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);
  }
  public hideChildModal():void{
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);    
  }

  public dataEdited():void{
    if(this.editPointRef){
      this.editPointRef.Status = this.editStatusValue;
      this.areChangesMade = true;
    }
    this.childModal.hide();
    
    this.scrlDiv.nativeElement.scrollIntoView(false);
  }
  public getPointStatusSrc(_tmpStatus):string{
    switch(_tmpStatus){
      case "0":
        return "/assets/rad-grey.png";  
      case "1":
        return "/assets/rad-green.png";  
      case "2":
        return "/assets/rad-yellow.png";  
      case "3":
        return "/assets/rad-red.png";  
    }

    return "/assets/rad-grey.png";
  }
  public prevMonthSel(): void {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  public nextMonthSel() {
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1);
    this.currMonthDtObj.setDate(1);
    this.loadMonthData();
  }
  
  loadMonthData() {
    this.isLoading = true;
    this.isLoaded = false;
    this.isFailed = false;
    this.failMessage = '';
    this.areChangesMade = false;
    this._dataService.loadNwcmTreeStatus(this.currMonthDtObj).subscribe((_nwcmMonthData: NWCMStatusMonthData) => {
      this.editDocId = "";
      this.editMonthStr = "";
      this.editNwcTreeDocTs = null;
      this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
        _tmpPointDef.Status = "0";
        _tmpPointDef.ImageRef = "";
      });
       if (_nwcmMonthData != null) {
        this.editDocId = _nwcmMonthData.ID;
        this.editMonthStr = _nwcmMonthData.SelMonth;
        this.editNwcTreeDocTs = _nwcmMonthData.docTs;
        _nwcmMonthData.Points.forEach((_tmpNwcmPoint:NWCMPointData) => {
          this._pointArray.forEach((_tmpPointDef:NWCMPointDef)=>{
            if(_tmpNwcmPoint.KPIId == _tmpPointDef.PointId){
              _tmpPointDef.Status = _tmpNwcmPoint.KPIStatus;
              _tmpPointDef.ImageRef = _tmpNwcmPoint.KPIImageRef;
            }
          });
        });
        // this.isLoaded = true;
        // this.isLoading = false;
        // this.isFailed = false;
       }
      // else {
      //   this.isLoaded = false;
      //   this.isLoading = false;
      //   this.isFailed = true;
      //   this.failMessage = "Failed to get data from database, try again";
      //  }
      this.isLoaded = true;
      this.isLoading = false;
      this.isFailed = false;
    });
  }

  saveData(_sendMail: boolean):void{
    if(this.validateData()==true){
      if(this.editMonthStr == ""){
        this.editMonthStr = GenService.getDateFormatStr(this.currMonthDtObj,"YYYYMM")
      }
      let _nwcmPointAr:Array<NWCMPointData> = [];
      for(var i=0;i<this._pointArray.length;i++){
        _nwcmPointAr.push(new NWCMPointData(this._pointArray[i].PointId,this._pointArray[i].Status,this._pointArray[i].ImageRef,[]));
      }
      let _nwcmMonthObj:NWCMStatusMonthData = new NWCMStatusMonthData(this.editDocId,this.editMonthStr,_nwcmPointAr,this.editNwcTreeDocTs);
      this._dataService.saveNWCMTreeInfo(_nwcmMonthObj)
      .subscribe((resp:GenResponse) => {
        if(resp.status == "FAIL"){
          if (resp.errorCode == DataService.staleDataCode) {
            this.errorPopup.showErrorPopup("Stale Data", resp.details)
          } else {
            this._notify.error('Failure', resp.details, this._dataService.failureOptions);
          }
        }
        else{
          this._notify.success('Success',resp.details,this._dataService.successOptions);
          this.loadMonthData();
        }
      });
    }
  }

  validateData():boolean{
    return true;
  }
  discardData():void{
    this.loadMonthData();
  }

  goToBottom(location: string): void {
    setTimeout(() => {
      window.location.hash = location;  
    }, 10);
    
  }
  openEnlargeImageModal():void{
    this.enlargeImageModal.show();
  }
  closeEnlargeImageModal(){
    this.enlargeImageModal.hide();
  }
}
